import {
  react,
  next_js,
  redux,
  redux_saga,
  angular,
  bootstrap,
  html,
  css,
  tailwindcss,
  material_ui,
  javascript,
  typescript,
  nodejs,
  express,
  mongodb,
  github,
  adobe_xd,
  figma,
  aws,
  heroku,
  stripe,
} from "assets/img/skills";

import {
  englishcafe1,
  englishcafe2,
  englishcafe3,
  travelfine1,
  travelfine2,
  feedu1,
  feedu2,
  feedu3,
  feedu4,
  feedu5,
  smartschool1,
  smartschool2,
  smartschool3,
  smartschool4,
  travelfine_dashboard1,
  travelfine_dashboard2,
} from "assets/img/projects";

const PortfolioData = [
  {
    id: 1,
    title: "EnglishCafe",
    images: [englishcafe1, englishcafe2, englishcafe3],
    tag: ["react", "node", "all"],
    delayAnimation: "0",
    modalDetails: [
      {
        project: "Web-Application",
        description:
          "It is a platform that connects students with teachers online and offline.",
        techStack: [
          { title: "React", icon: react },
          { title: "NextJs", icon: next_js },
          { title: "Redux", icon: redux },
          { title: "Html5", icon: html },
          { title: "CSS3", icon: css },
          { title: "TailwindCss", icon: tailwindcss },
          { title: "Material UI", icon: material_ui },
          { title: "Javascript", icon: javascript },
          { title: "Nodejs", icon: nodejs },
          { title: "Express", icon: express },
          { title: "Mongodb", icon: mongodb },
          { title: "Github", icon: github },
          { title: "Aws", icon: aws },
          { title: "Heroku", icon: heroku },
          { title: "Stripe", icon: stripe },
        ],
        preview: "marketplace.englishcafe.es",
        link: "https://marketplace.englishcafe.es/",
      },
    ],
  },
  {
    id: 2,
    title: "TravelFine",
    images: [travelfine1, travelfine2],
    tag: ["react", "node", "all"],
    delayAnimation: "100",
    modalDetails: [
      {
        project: "Web-App",
        description:
          "It is a project which helps users purchase insurance during their travels.",
        techStack: [
          { title: "React", icon: react },
          { title: "Redux Saga", icon: redux_saga },
          { title: "Html5", icon: html },
          { title: "CSS3", icon: css },
          { title: "TailwindCss", icon: tailwindcss },
          { title: "Material UI", icon: material_ui },
          { title: "Typescript", icon: typescript },
          { title: "Nodejs", icon: nodejs },
          { title: "Express", icon: express },
          { title: "Mongodb", icon: mongodb },
          { title: "Github", icon: github },
          { title: "Figma", icon: figma },
          { title: "Heroku", icon: heroku },
          { title: "Aws", icon: aws },
          { title: "Stripe", icon: stripe },
        ],
        preview: "dashboard.travelfine.es",
        link: "https://dashboard.travelfine.es",
      },
    ],
  },
  {
    id: 3,
    title: "Feedu",
    images: [feedu5, feedu1, feedu2, feedu3, feedu4],
    tag: ["react", "node", "all"],
    delayAnimation: "200",
    modalDetails: [
      {
        project: "Web-App",
        description:
          "It is a food-related social media platform where you will have an experience of everything and more than what other social media platforms offer.",
        techStack: [
          { title: "React", icon: react },
          { title: "Redux", icon: redux },
          { title: "Html5", icon: html },
          { title: "CSS3", icon: css },
          { title: "Material UI", icon: material_ui },
          { title: "Javascript", icon: javascript },
          { title: "Typescript", icon: typescript },
          { title: "Nodejs", icon: nodejs },
          { title: "Express", icon: express },
          { title: "Mongodb", icon: mongodb },
          { title: "Github", icon: github },
          { title: "Adobe Xd", icon: adobe_xd },
        ],
        preview: "food-book.co",
        link: "https://food-book.co",
      },
    ],
  },
  {
    id: 4,
    title: "SmartSchool",
    images: [smartschool1, smartschool2, smartschool3, smartschool4],
    tag: ["angular", "all"],
    delayAnimation: "200",
    modalDetails: [
      {
        project: "Web-App",
        description:
          "It is website that lets users generally school owners create custom websites for their schools.",
        techStack: [
          { title: "Angular", icon: angular },
          { title: "Bootstrap", icon: bootstrap },
          { title: "Html5", icon: html },
          { title: "CSS3", icon: css },
          { title: "Typescript", icon: typescript },
          { title: "Nodejs", icon: nodejs },
          { title: "Express", icon: express },
          { title: "Mongodb", icon: mongodb },
          { title: "Github", icon: github },
          { title: "Adobe Xd", icon: adobe_xd },
          { title: "Aws", icon: aws },
        ],
        preview: "feed-u.co",
        link: "https://feed-u.co",
      },
    ],
  },
  {
    id: 5,
    title: "Travelfine Dashboard",
    images: [travelfine_dashboard1, travelfine_dashboard2],
    tag: ["react", "node", "all"],
    delayAnimation: "200",
    modalDetails: [
      {
        project: "Web-App",
        description: "It was an admin dashboard for travel fine project.",
        techStack: [
          { title: "React", icon: react },
          { title: "Redux Saga", icon: redux_saga },
          { title: "Html5", icon: html },
          { title: "CSS3", icon: css },
          { title: "TailwindCss", icon: tailwindcss },
          { title: "Material UI", icon: material_ui },
          { title: "Typescript", icon: typescript },
          { title: "Nodejs", icon: nodejs },
          { title: "Express", icon: express },
          { title: "Mongodb", icon: mongodb },
          { title: "Github", icon: github },
          { title: "Figma", icon: figma },
          { title: "Heroku", icon: heroku },
          { title: "Aws", icon: aws },
        ],
      },
    ],
  },
];

export default PortfolioData;
